export default {"src":"/_next/static/media/get_colearn_on_app_store.6cb44e52.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};